import { render } from "./HoroEdit.vue?vue&type=template&id=17633ab5"
import script from "./HoroEdit.vue?vue&type=script&lang=js"
export * from "./HoroEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__